import {
  formatDateMonth,
  formatMonthColumn,
  formatMonthShort,
} from "@/components/demands/month-format";

export { formatDateMonth, formatMonthColumn, formatMonthShort };

/** Hours with a thousands separator and at most one decimal: 1234.5 → "1,234.5". */
export function formatHrs(hours: number): string {
  return hours.toLocaleString("en-US", { maximumFractionDigits: 1 });
}

/** Hours with the unit every number on these screens carries. */
export function hrs(hours: number | null): string {
  return hours === null ? "–" : `${formatHrs(hours)} hrs`;
}

/** 0.9234 → "92%"; null → "–". */
export function pct(ratio: number | null): string {
  return ratio === null ? "–" : `${Math.round(ratio * 100)}%`;
}

/** `2026-10-31T06:00:00.000Z` → "31 Oct, 06:00". */
export function formatAsOf(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      });
}

/** True when `iso` is more than 24 hours before now (the "sync stale" rule). */
export function isStale(iso: string, now: Date = new Date()): boolean {
  const t = Date.parse(iso);
  return Number.isFinite(t) && now.getTime() - t > 24 * 60 * 60 * 1000;
}

export const BASIS_LABEL = {
  actual: "Guidance vs Actuals",
  inProgress: "Month in progress — actuals to date",
  forecast: "Forecast: Guidance vs Capacity",
} as const;
